import {getHttpTransportUrl} from '#/utils/get-http-transport-url';
import {createCustomWeb3AuthConnector} from '#/wagmi/create-custom-web3auth-connector';
import {getChains} from '#/wagmi/get-chains';
import {getWeb3AuthInstance} from '#/wagmi/get-web3auth-instance';
import {createClient, http} from 'viem';
import {createConfig} from 'wagmi';

const chains = getChains();
export const web3AuthInstance = getWeb3AuthInstance(chains[0]);

export const wagmiConfig = createConfig({
  chains,
  client({chain}) {
    const transport = http(getHttpTransportUrl(chain));
    return createClient({chain, transport, batch: {multicall: true}});
  },
  connectors: [
    createCustomWeb3AuthConnector({
      web3AuthInstance,
    }),
  ],
  multiInjectedProviderDiscovery: false,
});
